import { gql } from '@apollo/client'

// Types
export type BackyardLoan = {
  loanId: string
  loanNumber: string | null
  agentTransactionId: number | null
  created: string
  updated: string | null
  loanAmount: number | null
  loanStatus: string | null
  losLoanStatus: string | null
  customerLoanStatus: string | null
  loanPurpose: string | null
  fileStartedDate: string | null
  coborrowerFirstName: string | null
  coborrowerLastName: string | null
  coborrowerEmail: string | null
  losVendor: string | null
  posVendor: string | null
  posFileId: string | null
  loanType: string | null
  customerName: string | null
  customerEmail: string | null
  customerAddress: string | null
  correspondentLoanNumber: string | null
  subjectPropertyAddress: string | null
  partnerLoanNumber: string | null
  loanChannel: string | null
}

export type FilterableLoansResponse = {
  filterableLoans: {
    loans: BackyardLoan[]
    pagination: {
      totalCount: number
      limit: number
      offset: number
    }
  }
}

export type FilterableLoansVariables = {
  input: {
    pagination: {
      limit: number
      offset: number
    }
    sort?: {
      field: 'CREATED' | 'UPDATED' | 'AGENT_TRANSACTION_ID'
      direction: 'ASC' | 'DESC'
    }
    filters?: {
      loanId?: string
      loanNumber?: string
      agentTransactionId?: number
      loanProgram?: string[]
    }
  }
}

export type TransactionSearchResult = {
  transactionId: string
  address: string | null
  customerName: string | null
  customerEmail: string | null
}

export type SearchTransactionsResponse = {
  searchTransactionsForLinking: {
    transactions: TransactionSearchResult[]
  }
}

export type SearchTransactionsVariables = {
  input: {
    query: string
    limit?: number
  }
}

export type TransactionSuggestion = {
  agentTransactionId: string
  addressLine1: string | null
  addressLine2: string | null
  customerFirstName: string | null
  customerLastName: string | null
  customerEmail: string | null
}

export type TransactionSuggestionsResponse = {
  transactionSuggestionsByEmail: {
    transactions: TransactionSuggestion[]
  }
}

export type TransactionSuggestionsVariables = {
  input: {
    email: string
    address?: string
  }
}

export type AssignLoanResponse = {
  assignLoanToTransaction: {
    success: boolean
    agentTransactionId: number | null
    loanId: string | null
    error: {
      message: string
      code: string | null
    } | null
  }
}

export type AssignLoanVariables = {
  input: {
    loanId: string
    agentTransactionId: number
  }
}

// Queries
export const FILTERABLE_LOANS = gql`
  query filterableLoans($input: FilterableLoansInput!) {
    filterableLoans(input: $input) {
      loans {
        loanId
        loanNumber
        agentTransactionId
        created
        updated
        loanAmount
        loanStatus
        losLoanStatus
        customerLoanStatus
        loanPurpose
        fileStartedDate
        coborrowerFirstName
        coborrowerLastName
        coborrowerEmail
        losVendor
        posVendor
        posFileId
        loanType
        customerName
        customerEmail
        customerAddress
        correspondentLoanNumber
        subjectPropertyAddress
        partnerLoanNumber
        loanChannel
      }
      pagination {
        totalCount
        limit
        offset
      }
    }
  }
`

export const SEARCH_TRANSACTIONS_FOR_LINKING = gql`
  query searchTransactionsForLinking($input: SearchTransactionsInput!) {
    searchTransactionsForLinking(input: $input) {
      transactions {
        transactionId
        address
        customerName
        customerEmail
      }
    }
  }
`

export const TRANSACTION_SUGGESTIONS_BY_EMAIL = gql`
  query transactionSuggestionsByEmail($input: TransactionSuggestionsInput!) {
    transactionSuggestionsByEmail(input: $input) {
      transactions {
        agentTransactionId
        addressLine1
        addressLine2
        customerFirstName
        customerLastName
        customerEmail
      }
    }
  }
`

// Mutations
export const ASSIGN_LOAN_TO_TRANSACTION = gql`
  mutation assignLoanToTransaction($input: AssignLoanInput!) {
    assignLoanToTransaction(input: $input) {
      success
      agentTransactionId
      loanId
      error {
        message
        code
      }
    }
  }
`
